import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
export var TotalSupply = createPlugin({
    protocol: 'ERC721',
    type: 'GETTER',
    method: 'totalSupply',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc721' }),
                methodParams: {},
            },
            output: {
                totalSupply: new FctValue({ innerIndex: 0, destination: 'wei_amount' }),
            },
        });
    },
});
